/**
 * Reads the linked wallet address out of a Supabase auth `app_metadata` blob, where a SIWE
 * sign-in stores it as `web3.address`. Returns null when the metadata is missing, malformed,
 * or has no web3 address.
 */
export function readWeb3Address(appMetadata: unknown): string | null {
  if (typeof appMetadata !== 'object' || appMetadata == null || !('web3' in appMetadata)) {
    return null
  }
  const { web3 } = appMetadata
  if (typeof web3 !== 'object' || web3 == null || !('address' in web3)) {
    return null
  }
  const { address } = web3
  return typeof address === 'string' ? address : null
}
